jQuery(document).ready(function ($) {
  // escape hatch
  if (!document.body.classList.contains("page-template-page-start")) {
    localStorage.removeItem("emailStatus");
    return;
  }

  let user_email;
  let redirect_val = $("input[name=r]").val();

  // Form UI helper to show/hide login methods based on data retrieved about user email
  function showHideLoginMethods(emailStatus) {
    if (emailStatus == 2) {
      // if email AND phone exist
      $(".registration-method").removeClass("expanded");
      $(".login-method").removeClass("expanded");
      $(".login-buttons").addClass("expanded");
      $("#login-button-sms").removeClass("hidden");
      $(".login-header").addClass("expanded");
    }
    if (emailStatus == 1) {
      // if email exists but not phone
      $(".registration-method").removeClass("expanded");
      $(".login-method").removeClass("expanded");
      $(".login-buttons").addClass("expanded");
      $("#login-button-sms").addClass("hidden");
      $(".login-header").addClass("expanded");
    }
  }

  // Start form submission
  $(".start-form input[type=submit]").click(function (e) {
    e.preventDefault();

    const input = document.querySelector('input[name="start_email"]');
    const { valueMissing, typeMismatch } = input.validity;

    if (!input.validity.valid) {
      $(".start-form .gfield").addClass("gfield_error");
      if (valueMissing) {
        $(".start-form .validation_message").text(
          "Please enter your email address."
        );
      }
      if (typeMismatch) {
        $(".start-form .validation_message").text(
          "Please enter a valid email address."
        );
      }
      $(".start-form .validation_message").show();
    } else {
      $(".page-content-loader").fadeIn("150", function () {
        $(".error_message_wrap").slideUp();
      });

      let form = {
        action: "jumbo_check_email",
        email: input.value,
        redirect: redirect_val,
      };

      $.post(WP.ajax_url, form, function (emailStatus) {
        // store emailStatus code in local storage, in case it needs to be retrieved later
        // (such as after a failed password login attempt)
        localStorage.setItem("emailStatus", emailStatus);

        if (emailStatus == 3) {
          // user not on guest list
          let redirect =
            location.protocol +
            "//" +
            location.host +
            location.pathname +
            "?access=denied";
          window.location.href = redirect;
        } else if (emailStatus == 2 || emailStatus == 1) {
          showHideLoginMethods(emailStatus);
        } else if (emailStatus == 0) {
          // if no email exists
          $(".registration-method").addClass("expanded");
          $(".login-method").removeClass("expanded");
          $(".login-buttons").removeClass("expanded");
          $(".login-header").removeClass("expanded");
        } else {
          // open reg - user logged in
          localStorage.removeItem("emailStatus");
          window.location.href = emailStatus;
        }

        if (emailStatus == 0 || emailStatus == 1 || emailStatus == 2) {
          // Set all inputs
          $("#input_1").val(user_email);
          $("#input_1_1").val(user_email);
          $("#input_2_1").val(user_email);
          $("#input_5_15").val(user_email);

          // Fade out
          $(".start-form").removeClass("expanded");
          $(".page-content-loader").fadeOut("150");
        }
      });
    }
  });

  // Swap login form
  $(".js-method-show").on("click", function () {
    var tab = $(this).attr("href");

    if (tab == "#sms") {
      // If SMS confirmation, send first
      $(".page-content-loader").fadeIn("150");

      let input_val = $("input[name=start_email]").val();
      user_email = input_val;

      let form = {
        action: "jumbo_send_sms_code",
        email: input_val,
      };

      $.post(WP.ajax_url, form, function (smsStatus) {
        if (smsStatus != 0) {
          swapLoginForm(tab);
          $(".page-content-loader").fadeOut("150");
          $("#verify_code_input").focus();
        }
      });
    } else if (tab == "#email") {
      // If email, send magic link & refresh w/ status
      $(".page-content-loader").fadeIn("150");

      let input_val = $("input[name=start_email]").val();
      user_email = input_val;

      let form = {
        action: "jumbo_email_magic_link",
        email: input_val,
        redirect: redirect_val,
      };

      $.post(WP.ajax_url, form, function (emailStatus) {
        let redirect =
          location.protocol + "//" + location.host + location.pathname;

        if (emailStatus == 1) {
          redirect += "?send=true";
        } else {
          redirect += "?send=false";
        }

        window.location.href = redirect;
      });
    } else {
      // Otherwise just swap
      swapLoginForm(tab);
    }
  });

  function swapLoginForm(tab) {
    tab = tab.replace("#", "#login-method-");

    $(".login-method").removeClass("expanded");
    $(".login-buttons").removeClass("expanded");
    $(tab).addClass("expanded");
  }

  // Handle verification code form
  $("body").on("click", "input#verify_code_submit", function (e) {
    e.preventDefault();

    $(".page-content-loader").fadeIn("150");

    let code_val = $("input[name=verify_code]").val();

    let form = {
      action: "jumbo_check_sms_code",
      code: code_val,
      redirect: redirect_val,
    };

    $.post(WP.ajax_url, form, function (magicLink) {
      if (magicLink != 0) {
        $("#verify_code_error").hide();
        $(location).attr("href", magicLink);
      } else {
        $("#verify_code_error").show();
        $(".page-content-loader").fadeOut("150");
      }
    });
  });

  // Method swaps
  $(".js-method-reset").on("click", function () {
    $(".login-method").removeClass("expanded");
    $(".login-buttons").addClass("expanded");

    // If emailStatus present in localStorage on load
    if (localStorage.getItem("emailStatus")) {
      showHideLoginMethods(localStorage.getItem("emailStatus"));
    }
  });

  $(".js-method-reset-hard").on("click", function () {
    $(".login-form").removeClass("expanded");
    $(".reg-form").removeClass("expanded");
    $(".start-form").addClass("expanded");
    $("#start_email").focus();
  });

  // Address formatting & handling
  const hasCountry = $(".ginput_complex").hasClass("has_country");

  function updateGravityFormAddress() {
    // Dropdown class
    $(".ginput_complex > span").each(function () {
      // Add or remove dropdown class
      if ($(this).find("select").length != 0) {
        $(this).addClass("has_dropdown");
      } else {
        $(this).removeClass("has_dropdown");
      }

      // Zip code
      if ($(this).hasClass("address_zip")) {
        let zipInput = $(this).find("input");
        if (
          !hasCountry ||
          (hasCountry &&
            $(".ginput_complex .address_country option:selected").text() ===
              "United States")
        ) {
          // US zip codes, make it a number field
          zipInput.get(0).type = "number";
        } else {
          // Other zip codes, make it a text field
          zipInput.get(0).type = "text";
        }
      }
    });
  }

  if (hasCountry) {
    $(".ginput_complex").on("DOMSubtreeModified", updateGravityFormAddress);
  } else {
    updateGravityFormAddress();
  }

  // Dynamically add autocomplete attributes to login form
  const passwordForm = document.getElementById("login-method-password");
  if (passwordForm) {
    const emailInput = passwordForm.querySelector("#input_1");
    const passwordInput = passwordForm.querySelector("#input_2");
    emailInput.setAttribute("autocomplete", "off");
    passwordInput.setAttribute("autocomplete", "password");
  }
});
